import type { Site } from './site';
import type { Planning } from './planning';
import type { LearningProgram } from './learning-program';

export enum GroupStatus {
  /** "En planification" — being planned (no firm commitment yet). Merged former "Projected". */
  Unconfirmed = 'Unconfirmed',
  Confirmed = 'Confirmed',
}

export interface Group {
  id: string;
  name: string;
  planningId: string;
  planning?: Planning | null;
  learningProgramId: string;
  learningProgram?: LearningProgram | null;
  /** The centre (site) where the group is delivered. Required. */
  siteId: string;
  site?: Site | null;
  archived: boolean;
  status: GroupStatus;
  memberCount: number;
  /** Distinct teachers assigned across this group's planning slots. */
  assignedTeacherCount: number;
  /** Distinct rooms (locaux) assigned across this group's planning slots. */
  assignedRoomCount: number;
  /** Whether this group is delivered as work-study (alternance). */
  workStudy: boolean;
}

export interface CreateGroupRequest {
  name: string;
  planningId: string;
  learningProgramId: string;
  /** Required: the centre (site) where the group is delivered. */
  siteId: string;
  status?: GroupStatus;
  workStudy?: boolean;
}

/** Duplicate a group's sequencing into a new group (#557) — no members, no assignments. */
export interface DuplicateGroupRequest {
  /** Name of the new group. */
  name: string;
  /** Start date of the new group's planning (YYYY-MM-DD). */
  startDate: string;
}

export interface UpdateGroupRequest {
  id: string;
  name: string;
  planningId: string;
  learningProgramId: string;
  /** Required: the centre (site) where the group is delivered. */
  siteId: string;
  status: GroupStatus;
  archived?: boolean;
  workStudy?: boolean;
}

export interface GroupResponse {
  group: Group;
}

export interface GroupsResponse {
  groups: Group[];
}

export interface ActiveGroup {
  id: string;
  name: string;
  programId: string;
  programTitle: string;
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
  studentCount: number;
}

export interface ActiveGroupsResponse {
  groups: ActiveGroup[];
}
